var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrevDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 13,
    cy: 13,
    r: 13,
    transform: "rotate(-180 13 13)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7596 16.7662C16.4443 17.0779 15.9369 17.0779 15.6215 16.7662L13.5833 14.7511C12.9058 14.0813 12.5671 13.7464 12.5671 13.3288C12.5671 12.9112 12.9058 12.5763 13.5833 11.9065L15.6215 9.89141C15.9369 9.57966 16.4443 9.57966 16.7596 9.89142C16.9927 10.1218 17.0638 10.47 16.9398 10.7734L16.2043 12.5718C16.0515 12.9454 15.9751 13.1322 15.9751 13.3288C15.9751 13.5254 16.0515 13.7122 16.2043 14.0858L16.9398 15.8842C17.0638 16.1876 16.9927 16.5358 16.7596 16.7662ZM11.7596 16.7662C11.4443 17.0779 10.9369 17.0779 10.6215 16.7662L8.58328 14.7511C7.90581 14.0813 7.56707 13.7464 7.56707 13.3288C7.56707 12.9112 7.90581 12.5763 8.58328 11.9065L10.6215 9.89141C10.9369 9.57966 11.4443 9.57966 11.7596 9.89142C11.9927 10.1218 12.0638 10.47 11.9398 10.7734L11.2043 12.5718L11.2043 12.5718C11.0515 12.9454 10.9751 13.1322 10.9751 13.3288C10.9751 13.5254 11.0515 13.7122 11.2043 14.0858L11.2043 14.0858L11.9398 15.8842C12.0638 16.1876 11.9927 16.5358 11.7596 16.7662Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevDouble);
export default __webpack_public_path__ + "static/media/icon-prev-double.7f79717fff6121c2b0bdea2a3eebcd9c.svg";
export { ForwardRef as ReactComponent };